var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{style:({ 'background-color': _vm.colorEBikeBarraFormulario }),attrs:{"id":"landing-page"}},[_c('v-main',{staticClass:"#212226 mx-4 mt-6"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }